// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/export
export { default as routes } from './routes'




// WEBPACK FOOTER //
// ./src/app/adn/index.js